var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasOneValue
    ? _c(
        "w-row",
        { key: "single" },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-human-filter-edit-value-custom-input", {
                attrs: {
                  "input-type": _vm.fieldType,
                  label: _vm.getLabel(0),
                  filter: _vm.filter,
                },
                model: {
                  value: _vm.filter.Values[0],
                  callback: function ($$v) {
                    _vm.$set(_vm.filter.Values, 0, $$v)
                  },
                  expression: "filter.Values[0]",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm.hasTwoValues
    ? _c(
        "w-row",
        { key: "double" },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-human-filter-edit-value-custom-input", {
                attrs: {
                  "value-index": 0,
                  "input-type": _vm.fieldType,
                  label: _vm.getLabel(0),
                  filter: _vm.filter,
                },
                model: {
                  value: _vm.filter.Values[0],
                  callback: function ($$v) {
                    _vm.$set(_vm.filter.Values, 0, $$v)
                  },
                  expression: "filter.Values[0]",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-human-filter-edit-value-custom-input", {
                attrs: {
                  "value-index": 1,
                  "input-type": _vm.fieldType,
                  label: _vm.getLabel(1),
                  filter: _vm.filter,
                },
                model: {
                  value: _vm.filter.Values[1],
                  callback: function ($$v) {
                    _vm.$set(_vm.filter.Values, 1, $$v)
                  },
                  expression: "filter.Values[1]",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm.hasMultipleValues
    ? _c(
        "w-row",
        { key: "multiple" },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-human-filter-edit-value-custom-input", {
                attrs: {
                  multi: "",
                  "input-type": _vm.fieldType,
                  label: _vm.getLabel(0),
                  filter: _vm.filter,
                },
                model: {
                  value: _vm.filter.Values,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "Values", $$v)
                  },
                  expression: "filter.Values",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }